import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import {
  NE_CURRENT_TEST_SUITE,
  shouldFillNETestData,
} from 'components/NEForm/NETestdata/NETestSetup';

const NESteps = createContext({});

export const useNESteps = () => useContext(NESteps);

export const NEStepsContext = ({ children }) => {
  const [activeStep, setActiveStep] = useState(0);

  const [submittedValues, setSubmittedValues] = useState(
    shouldFillNETestData
      ? { ...NE_CURRENT_TEST_SUITE }
      : {
          step0: {},
          step1: {},
          step2: {},
          step3: {},
        }
  );

  const setSubmittedValuesWithStep = (step, values) => {
    setSubmittedValues((oldValues) => ({ ...oldValues, [`step${step}`]: values }));
  };

  const clearSubmittedValuesWithStep = (step) => {
    setSubmittedValues((oldValues) => ({ ...oldValues, [`step${step}`]: {} }));
  };
  // forced by react-hooks/exhaustive-deps
  const getSubmittedValuesWithStep = useCallback(
    (step) => submittedValues[`step${step}`],
    [submittedValues]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);

  const contextValue = useMemo(
    () => ({
      activeStep,
      setActiveStep,
      getSubmittedValuesWithStep,
      setSubmittedValuesWithStep,
      clearSubmittedValuesWithStep,
    }),
    [activeStep, setActiveStep, getSubmittedValuesWithStep]
  );

  return <NESteps.Provider value={contextValue}>{children}</NESteps.Provider>;
};
NEStepsContext.propTypes = {
  children: PropTypes.node.isRequired,
};
